const DAYS_IN_WEEK = 7;

const monthAndDayFormatter = new Intl.DateTimeFormat("en", {
    month: "short",
    day: "numeric",
});

const monthDayAndYearFormatter = new Intl.DateTimeFormat("en", {
    month: "short",
    day: "numeric",
    year: "numeric",
});

export const addWeeks = (weekStart: Date, amount: number): Date => {
    const nextWeek = new Date(weekStart);
    nextWeek.setDate(nextWeek.getDate() + amount * DAYS_IN_WEEK);
    return nextWeek;
};

export const getWeekStart = (date: Date): Date => {
    const weekStart = new Date(date);
    weekStart.setHours(12, 0, 0, 0);
    weekStart.setDate(weekStart.getDate() - ((weekStart.getDay() + DAYS_IN_WEEK - 1) % DAYS_IN_WEEK));
    return weekStart;
};

export const getWeekEnd = (weekStart: Date): Date => {
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + DAYS_IN_WEEK - 1);
    return weekEnd;
};

export const getWeekKey = (weekStart: Date): string => {
    const year = weekStart.getFullYear();
    const month = String(weekStart.getMonth() + 1).padStart(2, "0");
    const day = String(weekStart.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const parseCalendarDate = (date: string): Date => {
    const [year, month, day] = date.split("-").map(Number);
    return new Date(year, month - 1, day, 12);
};

export const formatWeekRange = (weekStart: Date): string => {
    const weekEnd = getWeekEnd(weekStart);
    if (weekStart.getFullYear() !== weekEnd.getFullYear()) {
        return `${monthDayAndYearFormatter.format(weekStart)} – ${monthDayAndYearFormatter.format(weekEnd)}`;
    }
    if (weekStart.getMonth() !== weekEnd.getMonth()) {
        return `${monthAndDayFormatter.format(weekStart)} – ${monthDayAndYearFormatter.format(weekEnd)}`;
    }
    return `${monthAndDayFormatter.format(weekStart)} – ${weekEnd.getDate()}, ${weekEnd.getFullYear()}`;
};

export const formatCompactWeekRange = (weekStart: Date): string => {
    const weekEnd = getWeekEnd(weekStart);
    if (weekStart.getMonth() !== weekEnd.getMonth()) {
        return `${monthAndDayFormatter.format(weekStart)} – ${monthAndDayFormatter.format(weekEnd)}`;
    }
    return `${monthAndDayFormatter.format(weekStart)} – ${weekEnd.getDate()}`;
};
